{
  "name": "shoukaku",
  "version": "4.3.0",
  "description": "A stable and updated wrapper around Lavalink",
  "main": "dist/index.js",
  "module": "dist/index.mjs",
  "types": "dist/index.d.ts",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.mjs",
      "require": "./dist/index.js"
    }
  },
  "scripts": {
    "build": "npm run build:ts && npm run build:docs",
    "build:ts": "tsup --config tsup-config.json",
    "build:docs": "typedoc",
    "lint": "eslint .",
    "prepare": "npm run build:ts"
  },
  "keywords": [
    "bot",
    "music",
    "lavalink",
    "api",
    "discord",
    "lavalink.js",
    "discord.js",
    "lavalink-api",
    "weeb-library"
  ],
  "engines": {
    "node": ">=18.0.0",
    "npm": ">=7.0.0"
  },
  "author": "Saya",
  "license": "MIT",
  "repository": {
    "type": "git",
    "url": "https://github.com/shipgirlproject/Shoukaku.git"
  },
  "dependencies": {
    "ws": "^8.19.0"
  },
  "devDependencies": {
    "@shipgirl/eslint-config": "^0.5.0",
    "@types/node": "^25.2.3",
    "@types/ws": "^8.18.1",
    "eslint": "^9.39.2",
    "tsup": "^8.5.1",
    "typedoc": "^0.28.17",
    "typescript": "^5.9.3"
  }
}
